
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 4v4a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h6a1 1 0 011 1zm-1 7H4a1 1 0 00-1 1v8a1 1 0 001 1h6a1 1 0 001-1v-8a1 1 0 00-1-1zm10 4h-6a1 1 0 00-1 1v4a1 1 0 001 1h6a1 1 0 001-1v-4a1 1 0 00-1-1zm0-12h-6a1 1 0 00-1 1v8a1 1 0 001 1h6a1 1 0 001-1V4a1 1 0 00-1-1z","fill-rule":"evenodd"}})])
          )
        }
      }
    